export default {"src":"/_next/static/media/tennis.eb9f185a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};